import { z } from 'zod'

import { Vault } from '@/business-logic/wallet'
import * as EncryptedWalletMap from './EncryptedWalletMap'

const VaultDTOSchema = z.object({
  // Version 1 had no version and backups properties
  version: z.literal('2').optional(),
  vault: z.string(),
  backups: z
    .object({
      v1: z.string().optional(),
    })
    .optional(),
})

export type VaultDTO = z.infer<typeof VaultDTOSchema>

export function mapDTOToDomain(dto: unknown): Vault {
  const { vault, backups } = VaultDTOSchema.parse(dto)

  const encryptedWallet = EncryptedWalletMap.mapDTOToDomain(vault)

  const encryptedV1Backup = backups?.v1
    ? EncryptedWalletMap.mapDTOToDomain(backups.v1)
    : undefined

  return Vault.create({
    version: '2',
    encryptedWallet,
    encryptedV1Backup,
  })
}

export function mapDomainToDTO(vault: Vault): VaultDTO {
  const encryptedWalletValue = EncryptedWalletMap.mapDomainToDTO(
    vault.getEncryptedWallet()
  )
  const v1Backup = vault.getV1BackupValue()
  const encryptedV1BackupValue = v1Backup
    ? EncryptedWalletMap.mapDomainToDTO(v1Backup)
    : undefined

  return {
    version: vault.getVersion(),
    vault: JSON.stringify(encryptedWalletValue),
    backups: {
      v1: JSON.stringify(encryptedV1BackupValue),
    },
  }
}
